export default "__VITE_PUBLIC_ASSET__d145c184__"